import actions from './actions';
import getters from './getters';
import mutations from './mutations';

export default {
  namespaced: true,
  state: {
    sidebar: {
      visible: false,
      type: '',
      position: 'left',
      title: '',
      subtitle: '',
      button: true,
      overlay: true,
      'heading-level': 3,
    },
    notifications: [],
    breadcrumbs: [],
    countries: [],
    stateProvince: [],
    warehouses: [],
    languages: [],
    currencies: [],
    stores: [],
    store: {},
    config: {},
    isLoading: false,
  },
  getters,
  actions,
  mutations,
};
